import { SnapshotIn, types as t } from 'mobx-state-tree';

export const UserExperience = t.model('UserExperience', {
  isSubmitAfterWarning: t.maybeNull(t.boolean),
  isClickSubmitWithinRemainTimeAndQuestion: t.optional(t.boolean, false),
  isSubmitAnyway: t.optional(t.boolean, false),
  isAnswersAllQuestions: t.optional(t.boolean, false),
  isChangedAfterDoubleCheck: t.optional(t.boolean, false),
  lastUserAnswers: t.maybeNull<any>(t.string),
  isDoubleCheck: t.optional(t.boolean, false),
  isClickSubmitOnTimeWithinRemainQuestion: t.optional(t.boolean, false),
  isSubmitOnTime: t.optional(t.boolean, false),
});

export interface UserExperienceSnapshotIn extends SnapshotIn<typeof UserExperience> {}
